import { useCallback, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase.js'
import { historyUnderlying, loadPositionHistory } from '../lib/positionHistory.js'
import { SCHWAB_SYNC_COMPLETE_EVENT } from './useAutoSync.js'

export function usePositionHistory(userId, symbol, refreshVersion = 0) {
  const underlying = historyUnderlying(symbol)
  const key = `${userId || ''}:${underlying}`
  const [attempt, setAttempt] = useState(0)
  const [state, setState] = useState({ key: null, status: 'loading', rows: [] })
  const retry = useCallback(() => setAttempt(value => value + 1), [])
  useEffect(() => {
    window.addEventListener(SCHWAB_SYNC_COMPLETE_EVENT, retry)
    window.addEventListener('focus', retry)
    return () => { window.removeEventListener(SCHWAB_SYNC_COMPLETE_EVENT, retry); window.removeEventListener('focus', retry) }
  }, [retry])
  useEffect(() => {
    const controller = new AbortController()
    setState({ key, status: 'loading', rows: [] })
    if (!userId || !underlying) { setState({ key, status: 'unavailable', rows: [] }); return }
    const timeout = setTimeout(() => {
      controller.abort()
      setState({ key, status: 'error', rows: [] })
    }, 20000)
    loadPositionHistory(supabase, userId, underlying, controller.signal)
      .then(rows => { if (!controller.signal.aborted) setState({ key, status: 'ready', rows }) })
      .catch(() => { if (!controller.signal.aborted) setState({ key, status: 'error', rows: [] }) })
      .finally(() => clearTimeout(timeout))
    return () => { clearTimeout(timeout); controller.abort() }
  }, [userId, underlying, key, refreshVersion, attempt])
  return { ...(state.key === key ? state : { status: 'loading', rows: [] }), retry }
}
